import { render } from "./edit-education-modal.vue?vue&type=template&id=62f7e790&ts=true"
import script from "./edit-education-modal.vue?vue&type=script&lang=ts"
export * from "./edit-education-modal.vue?vue&type=script&lang=ts"

import "./edit-education-modal.vue?vue&type=style&index=0&id=62f7e790&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__